import { Form } from "antd";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../loader/loader";
import PageTitle from "../page-header/PageHeader";

import { loadProduct } from "../../redux/actions/product/getAllProductAction";
import { loadSingleSale } from "../../redux/actions/sale/detailSaleAction";

import { loadAllCustomer } from "../../redux/actions/customer/getCustomerAction";
import { deleteSale } from "../../redux/actions/sale/deleteSaleAction";
import { updateSale } from "../../redux/actions/sale/updateSaleAction";
import SaleProductEditCard from "../Card/saleInvoice/SaleProductEditCard";

//PopUp

const EditDetailSale = () => {
	const { id } = useParams();
	let navigate = useNavigate();

	const [form] = Form.useForm();

	const [visible, setVisible] = useState(false);
	const [totalAmount, setTotalAmount] = useState(0);
	const [totalStems, setTotalStems] = useState(0);
	const [totalDue, setTotalDue] = useState(0);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
	const [date, setDate] = useState(null); // State for date
	const [documentation, setDocumentation] = useState(0);
	const [freight, setFreight] = useState(0);
	const [handling, setHandling] = useState(0);
	const [hsCode, setHsCode] = useState("");


	//dispatch
	const dispatch = useDispatch();
	const sale = useSelector(state => state.sales.sale);
	const { singleSaleInvoice } = sale ? sale : {};

	const updateInvoice = (invoiceId, fields) => {
		
		const { message } = dispatch(
			updateSale(invoiceId, Object.values(fields), totalDue, selectedCustomer, date, documentation, freight, handling, hsCode)
		);

		navigate(`/sale/${invoiceId}`);
	};

	//Delete Customer
	const onDelete = () => {
		try {
			dispatch(deleteSale(id));

			setVisible(false);
			toast.warning(`Sale : ${sale.id} is removed `);
			return navigate("/salelist");
		} catch (error) {
			console.log(error.message);
		}
	};
	// Delete Customer PopUp

	const handleVisibleChange = newVisible => {
		setVisible(newVisible);
	};

	useEffect(() => {
		dispatch(loadProduct({ page: 1, limit: 200 }));
	}, []);

	useEffect(() => {
		dispatch(loadAllCustomer({ page: 1, limit: 1000 }));
	  }, [dispatch]);

	useEffect(() => {
		dispatch(loadSingleSale(id));

		setTotalStems(
			singleSaleInvoice?.saleInvoiceProduct.reduce(
				(p, item) => p + parseFloat(item.product_quantity),
				0
			)
		);

		setTotalAmount(
			singleSaleInvoice?.saleInvoiceProduct.reduce(
				(p, item) =>
					p +
				parseFloat(item.product_sale_price) *
				parseFloat(item.pack_rate) *
				parseFloat(item.boxes),
				0
			)
		);

		setTotalDue(singleSaleInvoice?.due_amount);
		setDocumentation(singleSaleInvoice?.documentation || 0);
		setFreight(singleSaleInvoice?.freight || 0);
		setHandling(singleSaleInvoice?.handling || 0);
		setHsCode(singleSaleInvoice?.hs_code || "");
	}, [id]);

	const isLogged = Boolean(localStorage.getItem("isLogged"));
	const allProducts = useSelector(state => state.products.list);
	const allCustomers = useSelector(state => state.customers.list);


	if (!isLogged) {
		return <Navigate to={"/auth/login"} replace={true} />;
	}

	return (
		<div>
			<PageTitle title="Edit Invoice" />

			<div className="mr-tops">
				{singleSaleInvoice ? (
					<Fragment key={singleSaleInvoice.id}>
						<SaleProductEditCard
							invoiceId={singleSaleInvoice.id}
							invoiceProducts={
								singleSaleInvoice.saleInvoiceProduct
							}
							updateInvoice={updateInvoice}
							setAmount={setTotalAmount}
							setStems={setTotalStems}
							setDue={setTotalDue}
							paid={singleSaleInvoice.paid_amount}
							products={allProducts}
							customer={singleSaleInvoice.customer}
							allCustomers={allCustomers}
							selectedCustomer={selectedCustomer}
							date={singleSaleInvoice.date}
							setDate={setDate}
							documentation={documentation}
							setDocumentation={setDocumentation}
							freight={freight}
							setFreight={setFreight}
							handling={handling}
							setHandling={setHandling}
							hsCode={hsCode}
							setHsCode={setHsCode}
							totals={
								<table>
									<tbody>
										<tr>
											<th>Total amount</th>
											<td>
												USD {totalAmount?.toFixed(2)}
											</td>
										</tr>
										<tr>
											<th>Paid amount</th>
											<td>
												USD{" "}
												{singleSaleInvoice.paid_amount?.toFixed(
													2
												)}
											</td>
										</tr>
										<tr>
											<th>Total due</th>
											<td>USD {totalDue?.toFixed(2)}</td>
										</tr>
										<tr>
											<th>Total stems</th>
											<td>{totalStems}</td>
										</tr>
									</tbody>
								</table>
							}
							setSelectedCustomer={setSelectedCustomer}
						/>
					</Fragment>
				) : (
					<Loader />
				)}
			</div>
		</div>
	);
};

export default EditDetailSale;
